import React from 'react';

export const PollsIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 18.5C5 18.7761 5.22386 19 5.5 19H6.5C6.77614 19 7 18.7761 7 18.5V8.5C7 8.22386 6.77614 8 6.5 8H5.5C5.22386 8 5 8.22386 5 8.5V18.5ZM9 18.5C9 18.7761 9.22386 19 9.5 19H10.5C10.7761 19 11 18.7761 11 18.5V4.5C11 4.22386 10.7761 4 10.5 4H9.5C9.22386 4 9 4.22386 9 4.5V18.5ZM13 18.5C13 18.7761 13.2239 19 13.5 19H14.5C14.7761 19 15 18.7761 15 18.5V12.5C15 12.2239 14.7761 12 14.5 12H13.5C13.2239 12 13 12.2239 13 12.5V18.5ZM17.5 8C17.2239 8 17 8.22386 17 8.5V18.5C17 18.7761 17.2239 19 17.5 19H18.5C18.7761 19 19 18.7761 19 18.5V8.5C19 8.22386 18.7761 8 18.5 8H17.5Z"
            fill="white"
            className={`icon-fill-secondary icon-fill-active-accent`}
        />
    </svg>
);
